import { Modal } from "antd";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessPopup = ({ open, close, text }) => {
  return (
    <div>
      <Modal
        width={190}
        height={70}
        open={open}
        onCancel={() => close(false)}
        footer={false}
        closable={false}
        style={{ marginTop: "130px" }}
      >
        <div className="success-modal text-center">
          <CheckCircleIcon style={{ fontSize: "44px", color: "green" }} />
          <p className="sent-successfully">{text}</p>
        </div>
      </Modal>
    </div>
  );
};

export default SuccessPopup;
